<template>
  <button
    v-if="hasJobLink"
    type="button"
    class="msc-ag-job-link"
    @click.stop="openJob"
  >
    <u>{{ displayJobName }}</u>
  </button>
  <span v-else>{{ displayJobName }}</span>
</template>

<script>
export default {
  name: 'MscReportJobLinkCell',
  computed: {
    displayJobName() {
      const data = this.params && this.params.data;
      const v = (this.params && this.params.value) ?? (data && data.job_name);
      if (v == null || v === '' || v === '-') return '';
      return v;
    },
    hasJobLink() {
      const data = this.params && this.params.data;
      const id = data && data.operation_id;
      return id != null && !String(id).startsWith('new-');
    },
  },
  methods: {
    refresh() {
      return true;
    },
    openJob() {
      const parent = this.params && this.params.context && this.params.context.componentParent;
      if (parent && this.params && this.params.data) {
        parent.jobNumberClick(this.params.data);
      }
    },
  },
};
</script>

<style scoped>
.msc-ag-job-link {
  background: none;
  border: none;
  color: inherit;
  cursor: pointer;
  font: inherit;
  padding: 0;
  text-align: left;
  white-space: nowrap;
}
</style>
